import { resolveConvorcherApiTarget } from './convorcherTargets'

export const API_TARGET = resolveConvorcherApiTarget(import.meta.env)
export const IS_LOCAL = /localhost|127\.0\.0\.1/.test(API_TARGET)

const _params = typeof window !== 'undefined'
  ? new URLSearchParams(window.location.search)
  : new URLSearchParams()

// FORCE_SHOW: true when running local OR when ?debugserver=1 is in the URL.
// URL param alone does NOT change the proxy — only shows the indicator.
export const FORCE_SHOW = IS_LOCAL || _params.has('debugserver')

if (IS_LOCAL) {
  console.warn(
    '%c⚠ LOCAL DEV SERVER — ' + API_TARGET + ' — NOT remote staging',
    'background:#f80;color:#000;font-weight:bold;padding:4px 10px;font-size:13px'
  )
} else {
  console.log('[server] remote:', API_TARGET)
}
